import React, { useState } from "react";
import bgImage from "../../assets/bg-login.jpg";
import Navbar from "./NavBar";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  // 🔘 This is now the single source of truth for the toggle
  const [isCollapsed, setIsCollapsed] = useState(false);

  const layoutStyle = {
    backgroundImage: `url(${bgImage})`,
    backgroundColor: "#f1f5f9",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div style={layoutStyle}>
      <Navbar />
      
      <div
        style={{
          display: "flex",
          marginTop: "60px", 
          flex: 1, 
          alignItems: "stretch", 
          position: "relative",
          minHeight: "calc(100vh - 60px)",
        }}
      >
        {/* 🧱 THE ASIDE CONTAINER */}
        <aside
          style={{
            position: "sticky",
            top: "60px",
            height: "calc(100vh - 60px)", 
            // ✅ Sizing shifts dynamically based on click toggle (70px minimized, 240px expanded)
            width: isCollapsed ? "70px" : "240px",
            transition: "width 0.3s ease",
            backgroundColor: "#1a1a1a",
            zIndex: 1000,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto", 
            overflowX: "hidden",
          }}
        >
          {/* ✅ Successfully forwarding parameters so clicking buttons toggles layout width */}
          <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        </aside>

        <main
          style={{
            flex: 1,
            padding: "20px 40px",
            minWidth: 0,
            backgroundColor: "rgba(248, 250, 252, 0.4)", 
            backdropFilter: "blur(12px)", 
            WebkitBackdropFilter: "blur(12px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "100%" }}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;